import React from 'react';
import {FieldHelper} from "cstar-react-primitives";

import {useFormatMessage} from '../../../intl/intlHooks';
import {useSettings} from '../../../mall_settings/SettingsProvider';

import {termsAgreementInfoFieldMessages} from './formFieldMessages';

export const TERMS_AGREEMENT_INFO = 'termsAgreementInfo';
export const TermsAgreementInfoField = () => {
    const { privacyPolicyUrl, termsOfUseUrl } = useSettings();
    const formatMessage = useFormatMessage();
    const info = termsOfUseUrl && privacyPolicyUrl ? formatMessage(termsAgreementInfoFieldMessages.policyAndAgreementLinks, {
        terms: str => <a key="terms-of-use" href={termsOfUseUrl} className="terms-of-use" target="_blank" rel="noopener noreferrer">{str}</a>,
        policy: str => <a key="privacy-policy" href={privacyPolicyUrl} className="privacy-policy" target="_blank" rel="noopener noreferrer">{str}</a>,
    }) : 'By completing your order, you agree to the Blackhawk Network Terms of Use and Privacy Policy. ' +
         'You also acknowledge that the prepaid cards offered through this site are sold by Blackhawk Network, Inc.';
    return (
        <FieldHelper
            id={TERMS_AGREEMENT_INFO}
            helper={info}
        />
    );
};
